import React, {useContext, useEffect, useReducer} from "react"
import { transformGFHGigs } from '../transformers'
import { searchGigs } from './searchGigs'

import {  FirebaseContext } from 'components/common/Firebase'
import { AuthorizedUserContext } from 'components/common/AuthorizedUser'

import SavedSearchSource from 'sources/SavedSearches'

const LiveGigsContext = React.createContext()

const defaultFilters = {
    city: '',
    distance: 0,
    compensation: 0,
    compensationType: 'hourly',
    keywords: ''
}

const loadFilter = (searches, name) => {
    console.log('Searching for:', name, 'in', searches)
    let result = searches.find(s => s.name === name)
    console.log(result)
    if (!result) {
        console.log('Using default')
        return defaultFilters
    }
    return { ...result.filters }
}

const liveGigsReducer = (state, action) => {

    console.log('Reducer:', action)

    switch (action.type) {
        case 'setfilter':
            const { id, value } = action.payload
            const { filters } = state
            state = {
                ...state,
                filters: {
                    ...filters,
                    [id]: value
                }
            }
            break
        case 'reset':
            state = {
                ...state,
                filters: defaultFilters,
                pageToken: null,
                hasMore: false,
                searchName: ''
            }
            break
        case 'reload':
            state = {
                ...state,
                liveGigs: null,
                liveGigsError: null,
                liveGigsLoaded: false,
                fetchingLiveGigs: true,
            }
            break
        case 'receiveGigs':
            state = {
                ...state,
                liveGigs: action.payload.gigs,
                liveGigsError: null,
                liveGigsLoaded: true,
                fetchingLiveGigs: false,
                pageToken: action.payload.token,
                hasMore: action.payload.gigs.length < action.payload.total
            }
            console.log('new state:', state)
            break
        case 'addPage':
            console.log('Add a page')
            const newGigs = state.liveGigs.concat(action.payload.gigs)
            state = {
                ...state,
                liveGigs: newGigs,
                liveGigsError: null,
                liveGigsLoaded: true,
                fetchingLiveGigs: false,
                pageToken: action.payload.token,
                hasMore: newGigs.length < action.payload.total
            }
            console.log('new state:', state)
            break
        case 'loadSearch':
            console.log('Load search', action.payload)
            state = {
                ...state,
                filters: loadFilter(state.searches, action.payload.name),
                searchName: action.payload.name
            }
            break
        case 'fetchSearches':
            state = {
                ...state,
                loadingSearches: true,
                searches: [],
                searchName: ''
            }

            break
        case 'receiveSearches':
            const { searches } = action.payload
            const newFilters = loadFilter(searches, state.searchName)
            state = {
                ...state,
                loadingSearches: false,
                searches,
                filters: newFilters,
                searchName: newFilters === defaultFilters ? '' : state.searchName
            }
            break
        case 'saveSearch':
            state = {
                ...state,
                searchName: action.payload.name
            }
            break
        default:
            console.log('Unknown action', action.type)
    }

    return state
}

const LiveGigsProvider = (props) => {

    const firebase = useContext(FirebaseContext)
    const authorizedUser = useContext(AuthorizedUserContext)

    const initialState = {
        filters: defaultFilters,
        searchName: '',
        searches: [],
        loadingSearches: false,
        liveGigs: null,
        liveGigsError: null,
        liveGigsLoaded: false,
        fetchingLiveGigs: false,
        pageToken: null,
        hasMore: true
    }

    const saved = new SavedSearchSource(firebase.firestore)

    const [state, dispatch] = useReducer(liveGigsReducer, initialState)

    const fetchNewPage = () => {
        console.log('Fetching...')
        const { filters, pageToken, liveGigs } = state
        searchGigs(filters, pageToken, liveGigs.length, 100).then(res => {
            dispatch({
                type: 'addPage',
                payload: {
                    gigs: transformGFHGigs(res.data.gigs),
                    token: res.data.token,
                    total: res.data.totalSize
                }
            })
        })
    }

    const reloadPage = () => {
        console.log('Reloading...')
        const {filters} = state
        console.log('Loading with filters:', filters)
        dispatch({ type: 'reload' })
        searchGigs(filters, null, 0, 100).then(res => {
            console.log(res)
            dispatch({
                type: 'receiveGigs',
                payload: {
                    gigs: transformGFHGigs(res.data.gigs),
                    token: res.data.token,
                    total: res.data.totalSize
                }
            })
        })
    }
    
    const reset = () => dispatch({ type: 'reset' })
    
    const setFilter = (id, value) => {
        dispatch({
            type: 'setfilter',
            payload: { id, value }
        })
    }

    const loadSearches = () => {
        dispatch({ type: 'fetchSearches' })
        saved.savedSearchesFor(authorizedUser.uid)
            .then(searches => {
                console.log(searches)
                dispatch({
                    type: 'receiveSearches',
                    payload: {
                        searches
                    }
                })
            })
        return saved.watchSavedSearchesFor(authorizedUser.uid, searches => {
            console.log(searches)
            dispatch({
                type: 'receiveSearches',
                payload: {
                    searches
                }
            })
        })
    }

    const saveSearch = (name) => {
        const { searchName, searches, filters } = state
        if (!name) {
            name = searchName
        }
        console.log('Saving:', searchName)
        if (name && name !== '') {
            let srch = searches.find(s => s.name === name)
            if (srch) {
                srch.filters = {...filters}
            } else {
                srch = {name: name, filters: {...filters}}
            }
            console.log('Creating search', name)
            saved.createSavedSearchFor(authorizedUser.uid, name, filters)
                .then(() => dispatch({
                    type: 'saveSearch',
                    payload: {
                        name
                    }
                }))
        }
    }

    const loadSearch = name => {
        dispatch({
            type: 'loadSearch',
            payload: {
                name
            }
        })
        console.log('Before reload:', state)
        // reloadPage()
    }

    const deleteSearch = () => {
        const { searchName } = state
        if (searchName && searchName !== '') {
            saved.deleteSavedSearchFor(authorizedUser.uid, searchName)
            reset()
        }
    }
    
    useEffect(() => { // fetch and transform live gigs
        const cancel = loadSearches()
        reloadPage()
        return () => cancel()
    }, [])

    const context = {
        state: state,
        reload: reloadPage,
        fetch: fetchNewPage,
        reset,
        setFilter,
        saveSearch,
        loadSearch,
        deleteSearch
    }

    return (
        <LiveGigsContext.Provider value={context}>
            {props.children}
        </LiveGigsContext.Provider>
    );
}
export {LiveGigsContext, LiveGigsProvider}